import React from "react";

function ThreeDIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g>
          <circle cx="12" cy="12" r="12" fill="#177AB5"></circle>
          <g fill="#FFF" fillRule="nonzero" transform="translate(5.647 3.882)">
            <path d="M.172 3.815L6.352.038l6.182 3.778-6.181 3.949-6.181-3.95zM0 5.533L5.666 9.14v6.353L0 12.057V5.533zm12.706 0v6.525L7.04 15.492V9.139l5.666-3.606z"></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default ThreeDIcon;
